module.exports = __webpack_public_path__ + "img/bg-sp.27c3e917.png";